<template>
    <div>
        <fila-requisicoes-titulo-secao titulo="Requisições com erro"
                                       :exibirBotaoLimparSelecao="exibirLimparSelecao"
                                       :exibirBotaoSelecionarTodos="exibirSelecionarTodos"
                                       :exibirRefresh="true" @refresh="$emit('refresh')"
                                       @selecionarTodos="selecionarTodos"
                                       @limparSelecao="limparSelecao"/>

        <div class="area-conteudo pt-2">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="requisicao in requisicoesComErro" :key="requisicao.id">
                        <requisicoes-com-erro-carrossel-card class="requisicao-card"
                                                             :requisicao="requisicao"
                                                             :selecionado="isSelecionado(requisicao)"
                                                             :baseUrl="baseUrl"
                                                             @marcarCard="marcarCard"
                                                             @desmarcarCard="desmarcarCard"/>
                    </div>
                </div>

                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
import RequisicoesComErroCarrosselCard from './RequisicoesComErroCarrosselCard'
import FilaRequisicoesTituloSecao from './FilaRequisicoesTituloSecao'
import Swiper from 'swiper/js/swiper'
import 'swiper/css/swiper.min.css'

export default {
    name: 'RequisicoesComErroCarrossel',
    components: {
        FilaRequisicoesTituloSecao,
        RequisicoesComErroCarrosselCard
    },
    props: {
        requisicoesComErro: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        baseUrl:{
            required: false,
            type: String,
            default: ''
        },
        exibirSelecionarTodos:{
            type: Boolean,
            default: false
        },
        exibirLimparSelecao:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            swiper: null,
            cardsMarcadosIds: []
        }
    },
    methods:{
        isSelecionado(card){
            return this.cardsMarcadosIds.includes(card.id)
        },
        limparSelecao(){
            this.cardsMarcadosIds = []
            this.$emit('limparSelecao')
        },
        selecionarTodos(){
            this.cardsMarcadosIds = this.requisicoesComErro.map(requisicao => {return requisicao.id})
            this.$emit('selecionarTodos')
        },
        marcarCard(requisicao){
            this.cardsMarcadosIds.push(requisicao.id)
            this.$emit('marcarCard', requisicao)
        },
        desmarcarCard(requisicao){
            const index = this.cardsMarcadosIds.indexOf(requisicao.id)
            if (index > -1) {
                this.cardsMarcadosIds.splice(index, 1)
            }
            this.$emit('desmarcarCard', requisicao)
        }
    },
    mounted() {
        if (this.requisicoesComErro.length > 0) {
            this.swiper = new Swiper('.swiper-container', {
                loop: false,
                autoHeight: true,
                slidesPerView: 1,
                a11y: true,
                keyboardControl: true,
                spaceBetween: 10,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1240: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    },
                    1640: {
                        slidesPerView: 5,
                        spaceBetween: 20
                    }
                }
            })
        }
    }
} //TODO rever aqui também
</script>

<style scoped lang="stylus">
    .area-conteudo
        position relative
        padding 0
        margin 5px 0 0

    .swiper-container
        height auto
        padding 0 20px
        box-shadow none
        width 100%

    .swiper-wrapper
        padding 0
        margin-bottom 30px

    .swiper-slide
        height auto
        font-size 14px
        background-color white
        display flex
        align-items center
        transition all .2s ease-in-out

    .swiper-slide:hover
        box-shadow 2px 2px 2px #c2c2c2
        transform translateY(-1px)
        cursor pointer

    .titulo-carrosel
        padding 10px 40px 0
        color var(--v-primary-darken1) !important
        font-weight bold
        font-size 16px

    .swiper-pagination-bullet
        width 20px
        height 20px
        text-align center
        line-height 20px
        font-size 12px
        color #000
        opacity 1
        background-color rgba(0, 0, 0, .2)

    .swiper-container-horizontal > .swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction
        bottom 0
</style>
